import { ref } from 'vue'
import { useRegisterSW } from 'virtual:pwa-register/vue'
import { isNativeApp } from '@/utils/native-platform'

let swRegistration: ServiceWorkerRegistration | null = null
let pendingReloadPath: string | null = null
const UPDATE_CHECK_INTERVAL_MS = 60 * 60 * 1000
let periodicChecksStarted = false

function disableServiceWorker() {
  navigator.serviceWorker
    ?.getRegistrations()
    .then((registrations) => registrations.forEach((r) => r.unregister()))
    .catch(() => {})

  return { needRefresh: ref(false), updateServiceWorker: async () => {} }
}

const { needRefresh, updateServiceWorker } = isNativeApp()
  ? disableServiceWorker()
  : useRegisterSW({
      immediate: true,
      onNeedReload() {
        window.location.assign(pendingReloadPath ?? window.location.href)
      },
      onRegisteredSW(_swScriptUrl, registration) {
        swRegistration = registration ?? null
      }
    })

function requestReload(path: string) {
  // Requests the waiting service worker take over, then reloads to `path`
  // once it actually has. Used by the router guard in router/index.ts so the
  // user lands on the destination they were navigating to, not the page they
  // were leaving.
  console.info(`[pwa-update] app update pending, reloading to ${path}`)
  pendingReloadPath = path
  updateServiceWorker()
}

function checkForUpdate() {
  // swallow network errors if the SW script request fails
  return swRegistration?.update().catch(() => {})
}

function startPeriodicUpdateChecks() {
  if (periodicChecksStarted || isNativeApp()) return
  periodicChecksStarted = true

  // check more frequently when the page is made visible
  setInterval(() => {
    if (document.visibilityState === 'visible') checkForUpdate()
  }, UPDATE_CHECK_INTERVAL_MS)

  // if backgrounded tab is made visible, check for update immediately.
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      checkForUpdate()
      return
    }
    if (needRefresh.value) {
      requestReload(window.location.href)
    }
  })
}

export { needRefresh, requestReload, checkForUpdate, startPeriodicUpdateChecks }
